var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWarningDiamond(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m13.858 25.916-7.77-7.77c-1.436-1.436-1.455-2.852-.03-4.278l7.82-7.81c1.425-1.425 2.842-1.406 4.277.03l7.76 7.76c1.437 1.436 1.446 2.862.03 4.278l-7.809 7.819c-1.426 1.416-2.842 1.407-4.278-.03zm1.18-8.896c.012.633.346.98.968.98.598 0 .944-.335.956-.98l.167-6.296c.012-.634-.478-1.1-1.135-1.1-.67 0-1.135.455-1.123 1.088zm-.37 3.91c0 .704.62 1.278 1.338 1.278s1.338-.562 1.338-1.279-.609-1.29-1.338-1.29c-.729 0-1.338.585-1.338 1.29z",
    fill: "#000",
    fillRule: "evenodd"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningDiamond);
export default __webpack_public_path__ + "static/media/Warning_Diamond.d60eceab37e114691cac773618bdd570.svg";
export { ForwardRef as ReactComponent };